import script from "./GameView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameView.vue?vue&type=script&setup=true&lang=ts"

import "./GameView.vue?vue&type=style&index=0&id=69c7c96b&scoped=true&lang=css"

import exportComponent from "/Users/samuel/KTH/DynWeb/ssoderbe-wrmvd-ht22-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69c7c96b"]])

export default __exports__